import './TicketPart.scss'

const TicketPart = ({ children, className = '' }) => {
    return <div className={`ticket-part ${className}`}>{children}</div>
}

export default TicketPart
